export default "__VITE_ASSET__jIR$buxM__"